import axios, {AxiosResponse} from 'axios'
import {ItemUnitQueryResponse} from './_model'

const API_URL = process.env.REACT_APP_BASE_API_URL
const URL = `${API_URL}/item-units`

const getItemUnit = (query: string): Promise<ItemUnitQueryResponse> => {
  return axios.get(`${URL}?${query}`).then((d: AxiosResponse<ItemUnitQueryResponse>) => d.data)
}

export {getItemUnit}
